import React from "react";
import {Col, FormFeedback, FormGroup, Label} from 'reactstrap';
import Cleave from 'cleave.js/react';

const DateInput = ({id, name, input_type, description, placeholder, value, options, onChange, required, errors}) => {
    if(errors) {
        console.log(errors[0]);
    }
    return (
        <div className="row mb-2">
            <div className="col-md-4 pr-md-1 align-self-center">
                <Label check>
                    {description} {!!required && '*'}
                </Label>
            </div>
            <div className="col-md-8">
                <div className="input-group">
                    {(options && options[0]?.prepend) && <div className="input-group-prepend">
                        <span className="input-group-text">{options[0].prepend}</span>
                    </div>}
                    <Cleave
                        placeholder={placeholder || `DD-MM-YYYY`}
                        className={`form-control ${!!errors ? ' is-invalid ' : ' '}`}
                        name={name}
                        value={value ?? ''}
                        onChange={(e) => {
                            onChange(id, {
                                [e.target.name]: e.target.value
                            })
                        }}
                        options={{
                            date: true,
                            dateFormatter: ['d', 'm', 'Y'],
                            delimiter: '-',
                        }}
                    />
                    {!!errors ? <FormFeedback className="d-block">{errors[0]}</FormFeedback> : ''}
                </div>
            </div>
        </div>
    )
}
export default DateInput;
